var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  (_vm.bgcShow == 1 && _vm.bgcisshow1 == 0) || (_vm.bgcShow == 0 && _vm.bgcisshow1 == 0)
    ? 'bgc'
    : 'aaa' ],attrs:{"id":"app"}},[(_vm.showBoXueGu)?_c('div',{staticClass:"logo-link"},[_c('img',{attrs:{"src":require("./assets/reset-pass/logo.png"),"alt":""}})]):_vm._e(),_c('router-view'),_c('myToast',{directives:[{name:"show",rawName:"v-show",value:(_vm.manyloginToast),expression:"manyloginToast"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }